import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var beginAwardBadgeFlow = createAction(reduxKey + "/BEGIN_AWARD_BADGE_FLOW", function (recipient) { return ({
    recipient: recipient,
}); });
export var awardBadge = createAction(reduxKey + "/AWARD", function (badgeType, recipient) { return ({
    badgeType: badgeType,
    recipient: recipient,
}); });
export var awardingBadge = createAction(reduxKey + "/AWARDING", function () { return ({}); });
export var awardBadgeSuccess = createAction(reduxKey + "/AWARD.SUCCESS", function (badge, recipient, newBalance) { return ({
    badge: badge,
    recipient: recipient,
    newBalance: newBalance,
}); });
export var awardBadgeFail = createAction(reduxKey + "/AWARD.FAIL", function (badgeType, recipient) { return ({
    badgeType: badgeType,
    recipient: recipient,
}); });
export var fetchAvailableBadges = createAction(reduxKey + "/FETCH_AVAILABLE_BADGES", function (userId) { return ({ userId: userId }); });
export var fetchAvailableBadgesSuccess = createAction(reduxKey + "/FETCH_AVAILABLE_BADGES.SUCCESS", function (userId, results) { return ({ userId: userId, results: results }); });
export var fetchBadgeGiverStreamNext = createAction(reduxKey + "/BADGE_GIVER_STREAM.FETCH_NEXT", function (streamId) { return ({ streamId: streamId }); });
//# sourceMappingURL=actionCreators.js.map